"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerInput = exports.DateFormatEnum = void 0;
var _StandardInput = _interopRequireDefault(require("../StandardInput/index.js"));
var _react = _interopRequireWildcard(require("react"));
var _Datepicker = _interopRequireDefault(require("../Datepicker/index.js"));
var _useOnClickOutside = _interopRequireDefault(require("../Hooks/useOnClickOutside.js"));
var _utils = require("./utils.js");
var _utils2 = require("../Datepicker/utils.js");
var _useTheme = require("../../../theme/themeProvider/useTheme.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let DateFormatEnum = exports.DateFormatEnum = /*#__PURE__*/function (DateFormatEnum) {
  DateFormatEnum["MM_DD_YYYY"] = "MM/DD/YYYY";
  DateFormatEnum["DD_MM_YYYY"] = "DD/MM/YYYY";
  DateFormatEnum["DD_MM_YY"] = "DD/MM/YY";
  DateFormatEnum["MM_DD_YY"] = "MM/DD/YY";
  DateFormatEnum["MONTH_DD_YYYY"] = "MMMM DD, YYYY";
  DateFormatEnum["WEEKDAY_MONTH_DD_YYYY"] = "Weekday, MMMM DD, YYYY";
  DateFormatEnum["DD_MMM_YYYY"] = "DD-MMM-YYYY";
  return DateFormatEnum;
}({});
const DatePickerInput = props => {
  const theme = (0, _useTheme.useTheme)();
  const {
    disabled,
    helperText,
    value = '',
    onDateChange,
    DateMode,
    startYear,
    minDate,
    maxDate = _utils.maximumDateAllowed,
    DateFormat = DateFormatEnum.MM_DD_YYYY,
    onChangeStartEndDateHandle,
    leftIcon,
    rightIcon,
    error,
    onBlur,
    placeholder,
    isFloatingLabel,
    hideLabelOnInput,
    isCurrentStartDate = false,
    zindexValue = "2",
    onClickLeftIcon,
    width = "100%",
    bg,
    errorColor,
    successColor,
    defaultBorderColor,
    defaultTextColor,
    disablebgColor,
    placeholderTextColor,
    helperTextColor,
    requiredTextColor,
    focusStateBorderColor,
    errorStateBorderColor,
    successStateBorderColor,
    disabledStateBorderColor,
    borderWidth,
    borderStyle,
    borderRadius,
    padding,
    margin,
    secondaryTextColor,
    hoverColor,
    valueStartDate,
    valueEndDate,
    datePickerPosition,
    inputBackground,
    dayRangeBg,
    daySelectedColor,
    dayRangeColor,
    paddingHorizontal,
    paddingVertical,
    placeHolderColor,
    focusColor,
    spacingIcon,
    onHoverDateRangeBgColor,
    monthYearColor,
    weekDaysColor,
    daysColor,
    disabledDaysColor,
    boxShadow,
    textFontSize,
    textFontFamily,
    textFontStyle,
    textTransformation,
    textFontWeight,
    wordSpacing,
    textIndent,
    textPadding,
    textMargin,
    textDecoration,
    letterSpacing,
    lineHeight = 16,
    textAlignment,
    textShadow,
    onLoadShowCalender = false,
    calenderBgColor,
    calenderBorderRadius,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    calenderBoxShadow,
    calenderAlignment,
    calenderPadding,
    calenderMargin,
    monthYearFontFamily,
    monthYearFontStyle,
    monthYearFontWeight,
    monthYearFontSize,
    monthYearTransformation,
    monthYearDecoration,
    hoverMonthYearTextColor,
    hoverMonthYearBgColor,
    weekFontFamily,
    weekFontStyle,
    weekFontWeight,
    weekFontSize,
    weekTransformation,
    weekDecoration,
    hoverWeekTextColor,
    hoverWeekBgColor,
    weekLineHeight = 16,
    dateWeekHeight = '40px',
    dateWeekWidth = '40px',
    dateWeekMargin,
    dateBgColor,
    hoverDateBgColor = theme.color.primary,
    dateBorderRadius,
    dateBorderWidth,
    dateBorderStyle,
    dateBorderColor,
    dateBoxShadow,
    dateFontFamily,
    dateFontStyle,
    dateFontWeight,
    dateFontSize,
    dateTransformation,
    dateDecoration,
    hoverDateTextColor = theme.color.defaultTextColor,
    dateLineHeight = 16,
    currentDateBgColor = theme.color.primary,
    currentDateBorderRadius,
    currentDateBorderWidth,
    currentDateBorderStyle,
    currentDateBorderColor,
    currentDateBoxShadow,
    currentDateFontFamily,
    currentDateFontStyle,
    currentDateFontWeight,
    currentDateFontSize,
    currentDateTransformation,
    currentDateDecoration,
    currentDateTextColor = theme.color.primaryBgColor,
    selectedDateBgColor = '#18BA92',
    selectedDateBorderRadius,
    selectedDateBorderWidth,
    selectedDateBorderStyle,
    selectedDateBorderColor,
    selectedDateBoxShadow,
    selectedDateFontFamily,
    selectedDateFontStyle,
    selectedDateFontWeight,
    selectedDateFontSize,
    selectedDateTransformation,
    selectedDateDecoration,
    selectedDateTextColor = theme.color.primaryBgColor,
    dateRangeBgColor,
    dateRangeBorderRadius,
    dateRangeBorderWidth,
    dateRangeBorderStyle,
    dateRangeBorderColor,
    dateRangeBoxShadow,
    dateRangeFontFamily,
    dateRangeFontStyle,
    dateRangeFontWeight,
    dateRangeFontSize,
    dateRangeTransformation,
    dateRangeDecoration,
    dateRangeTextColor,
    disabledDateBgColor,
    disabledDateBorderRadius,
    disabledDateBorderWidth,
    disabledDateBorderStyle,
    disabledDateBorderColor,
    disabledDateBoxShadow,
    disabledDateFontFamily,
    disabledDateFontStyle,
    disabledDateFontWeight,
    disabledDateFontSize,
    disabledDateTransformation,
    disabledDateDecoration,
    disabledDateTextColor,
    monthFontFamily,
    monthFontStyle,
    monthFontWeight,
    monthFontSize,
    monthTransformation,
    monthDecoration,
    monthTextColor,
    hoverMonthTextColor = theme.color.defaultTextColor,
    hoverMonthBgColor = '#E2F9F6',
    currentMonthBgColor = theme.color.primary,
    currentMonthBorderRadius,
    currentMonthBorderWidth,
    currentMonthBorderStyle,
    currentMonthBorderColor,
    currentMonthBoxShadow,
    currentMonthFontFamily,
    currentMonthFontStyle,
    currentMonthFontWeight,
    currentMonthFontSize,
    currentMonthTransformation,
    currentMonthDecoration,
    currentMonthTextColor = theme.color.primaryBgColor,
    selectedMonthBgColor = '#18BA92',
    selectedMonthBorderRadius,
    selectedMonthBorderWidth,
    selectedMonthBorderStyle,
    selectedMonthBorderColor,
    selectedMonthBoxShadow,
    selectedMonthFontFamily,
    selectedMonthFontStyle,
    selectedMonthFontWeight,
    selectedMonthFontSize,
    selectedMonthTransformation,
    selectedMonthDecoration,
    selectedMonthTextColor = theme.color.primaryBgColor,
    yearFontFamily,
    yearFontStyle,
    yearFontWeight,
    yearFontSize,
    yearTransformation,
    yearDecoration,
    yearTextColor,
    hoverYearTextColor = theme.color.defaultTextColor,
    hoverYearBgColor = '#E2F9F6',
    currentYearBgColor = theme.color.primary,
    currentYearBorderRadius,
    currentYearBorderWidth,
    currentYearBorderStyle,
    currentYearBorderColor,
    currentYearBoxShadow,
    currentYearFontFamily,
    currentYearFontStyle,
    currentYearFontWeight,
    currentYearFontSize,
    currentYearTransformation,
    currentYearDecoration,
    currentYearTextColor = theme.color.primaryBgColor,
    selectedYearBgColor = '#18BA92',
    selectedYearBorderRadius,
    selectedYearBorderWidth,
    selectedYearBorderStyle,
    selectedYearBorderColor,
    selectedYearBoxShadow,
    selectedYearFontFamily,
    selectedYearFontStyle,
    selectedYearFontWeight,
    selectedYearFontSize,
    selectedYearTransformation,
    selectedYearDecoration,
    selectedYearTextColor = theme.color.primaryBgColor,
    readOnly
  } = props;
  const [selectedDate, setSelectedDate] = (0, _react.useState)(value);
  const [selectedStartDate, setSelectedStartDate] = (0, _react.useState)(value);
  const [selectedEndDate, setSelectedEndDate] = (0, _react.useState)(value);
  const [open, setOpen] = (0, _react.useState)(false);
  const datePickerRef = (0, _react.useRef)(null);
  const datePickerContainerRef = (0, _react.useRef)(null);
  const initialDate = minDate || new Date(`01-01-${startYear}`) || _utils2.defaultStartDate;
  const openCalender = () => {
    setOpen(prev => !prev);
  };
  const hideDatePicker = () => {
    setOpen(false);
    onBlur && onBlur();
  };
  (0, _useOnClickOutside.default)(datePickerRef, hideDatePicker);
  (0, _react.useEffect)(() => {
    if (valueEndDate && isCurrentStartDate) {
      hideDatePicker();
    }
  }, [valueEndDate]);
  (0, _react.useEffect)(() => {
    if (valueStartDate || valueEndDate) {
      setSelectedStartDate(valueStartDate || "");
      setSelectedEndDate(valueEndDate || "");
      setSelectedDate(valueStartDate && valueEndDate ? `${valueStartDate}-${valueEndDate}` : valueStartDate || valueEndDate || "");
    }
  }, [valueStartDate, valueEndDate, DateFormat]);
  (0, _react.useEffect)(() => {
    let updatedFormat = value;
    if (typeof updatedFormat !== 'string') {
      updatedFormat = String(updatedFormat);
    }
    const dateRangeRegex = /(.+?)-(.+)/;
    const match = updatedFormat.match(dateRangeRegex);
    if (match) {
      const [startDateString, endDateString] = updatedFormat.split('-');
      const startDate = new Date(startDateString.trim());
      const endDate = new Date(endDateString.trim());
      setSelectedDate((0, _utils.formatMultipleDate)(startDate, endDate, DateFormat));
    } else {
      setSelectedDate((0, _utils.formatDate)(updatedFormat, DateFormat));
    }
  }, [value]);
  (0, _react.useEffect)(() => {
    if (open) {
      datePickerContainerRef?.current?.scrollIntoView?.({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'center'
      });
    }
  }, [datePickerContainerRef?.current, open]);
  const parsedValueDate = DateMode == 'date' && value ? new Date(value) : null;
  const valueDate = parsedValueDate && !isNaN(parsedValueDate.getTime()) ? new Date(parsedValueDate.getFullYear(), parsedValueDate.getMonth(), parsedValueDate.getDate()) : null;
  const handleDateChange = date => {
    setSelectedDate((0, _utils.formatDate)(date, DateFormat));
    onDateChange && onDateChange(date);
  };
  const handleKeyPress = e => {
    const code = e.charCode || e.which;
    if (e.keyCode === 8 && !disabled) {
      handleDateChange('');
      setSelectedDate('');
      setOpen(false);
    }
    if (code < 48 || code > 57 || DateFormat.length === e.target.value.length) {
      e.preventDefault();
    }
  };
  const handleTextChange = inputValue => {
    const formattedInput = (0, _utils.formatByPattern)(inputValue, DateFormat);
    setSelectedDate(formattedInput);
    if ((0, _utils.isValidDate)(formattedInput, DateFormat)) {
      handleDateChange(new Date(formattedInput));
    }
  };
  const handleBlur = e => {
    if (!(0, _utils.isValidDate)(e.target.value, DateFormat)) {
      setSelectedDate(e.target.value);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: datePickerRef,
    style: {
      width: width
    },
    children: [DateMode == 'range' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_StandardInput.default, {
      readOnly: readOnly,
      placeholder: placeholder,
      name: "Date",
      value: valueStartDate && valueEndDate ? `${valueStartDate}-${valueEndDate}` : '',
      disabled: disabled,
      helperText: helperText,
      leftIcon: leftIcon,
      textIcon: rightIcon,
      onFieldClick: openCalender,
      onClickIcon: openCalender,
      onKeyDown: handleKeyPress,
      onTextChange: handleTextChange,
      onBlur: handleBlur,
      error: error,
      isFloatingLabel: isFloatingLabel,
      hideLabelOnInput: hideLabelOnInput,
      onClickLeftIcon: onClickLeftIcon,
      bg: bg,
      errorColor: errorColor,
      successColor: successColor,
      defaultBorderColor: defaultBorderColor,
      defaultTextColor: defaultTextColor,
      disablebgColor: disablebgColor,
      placeholderTextColor: placeholderTextColor,
      helperTextColor: helperTextColor,
      requiredTextColor: requiredTextColor,
      focusStateBorderColor: focusStateBorderColor,
      errorStateBorderColor: errorStateBorderColor,
      successStateBorderColor: successStateBorderColor,
      disabledStateBorderColor: disabledStateBorderColor,
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      borderRadius: borderRadius,
      padding: padding,
      margin: margin,
      secondaryTextColor: secondaryTextColor,
      hoverColor: hoverColor,
      boxShadow: boxShadow,
      textFontSize: textFontSize,
      textFontFamily: textFontFamily,
      textFontStyle: textFontStyle,
      textTransformation: textTransformation,
      textFontWeight: textFontWeight,
      wordSpacing: wordSpacing,
      textIndent: textIndent,
      textPadding: textPadding,
      textMargin: textMargin,
      textDecoration: textDecoration,
      letterSpacing: letterSpacing,
      lineHeight: lineHeight,
      valueTextAlign: textAlignment,
      textShadow: textShadow,
      paddingHorizontal: paddingHorizontal,
      paddingVertical: paddingVertical,
      placeHolderColor: placeHolderColor,
      focusColor: focusColor,
      spacingIcon: spacingIcon
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_StandardInput.default, {
      readOnly: readOnly,
      placeholder: placeholder,
      name: "Date",
      value: typeof selectedDate === 'string' ? selectedDate : selectedDate?.toString(),
      disabled: disabled,
      helperText: helperText,
      leftIcon: leftIcon,
      textIcon: rightIcon,
      onFieldClick: openCalender,
      onClickIcon: openCalender,
      onKeyDown: handleKeyPress,
      onTextChange: handleTextChange,
      onBlur: handleBlur,
      error: error,
      isFloatingLabel: isFloatingLabel,
      hideLabelOnInput: hideLabelOnInput,
      onClickLeftIcon: onClickLeftIcon,
      bg: bg,
      errorColor: errorColor,
      successColor: successColor,
      defaultBorderColor: defaultBorderColor,
      defaultTextColor: defaultTextColor,
      disablebgColor: disablebgColor,
      placeholderTextColor: placeholderTextColor,
      helperTextColor: helperTextColor,
      requiredTextColor: requiredTextColor,
      focusStateBorderColor: focusStateBorderColor,
      errorStateBorderColor: errorStateBorderColor,
      successStateBorderColor: successStateBorderColor,
      disabledStateBorderColor: disabledStateBorderColor,
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      borderRadius: borderRadius,
      padding: padding,
      margin: margin,
      secondaryTextColor: secondaryTextColor,
      hoverColor: hoverColor,
      boxShadow: boxShadow,
      textFontSize: textFontSize,
      textFontFamily: textFontFamily,
      textFontStyle: textFontStyle,
      textTransformation: textTransformation,
      textFontWeight: textFontWeight,
      wordSpacing: wordSpacing,
      textIndent: textIndent,
      textPadding: textPadding,
      textMargin: textMargin,
      textDecoration: textDecoration,
      letterSpacing: letterSpacing,
      lineHeight: lineHeight,
      valueTextAlign: textAlignment,
      textShadow: textShadow
    }), (open || onLoadShowCalender) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: datePickerContainerRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Datepicker.default, {
        onDateChange: handleDateChange,
        mode: DateMode,
        startDate: isCurrentStartDate ? undefined : valueDate ? valueDate : (0, _utils.isValidDate)(selectedStartDate) ? new Date(selectedStartDate) : new Date(),
        selectedDate: valueDate ? valueDate : (0, _utils.isValidDate)(selectedDate, DateFormat) ? new Date(selectedDate) : new Date(),
        endDate: isCurrentStartDate ? undefined : (0, _utils.isValidDate)(selectedEndDate) ? new Date(selectedEndDate) : new Date(),
        minDate: initialDate,
        maxDate: maxDate,
        startYear: startYear,
        onChangeStartEndDateHandle: onChangeStartEndDateHandle,
        handleClose: () => setOpen(false),
        isCurrentStartDate: isCurrentStartDate,
        zindexValue: zindexValue,
        onLoadShowCalender: onLoadShowCalender,
        onHoverDateRangeBgColor: onHoverDateRangeBgColor,
        disabledDaysColor: disabledDaysColor,
        bg: calenderBgColor,
        borderRadius: calenderBorderRadius,
        calenderBorderWidth: calenderBorderWidth,
        calenderBorderStyle: calenderBorderStyle,
        calenderBorderColor: calenderBorderColor,
        calenderBoxShadow: calenderBoxShadow,
        calenderAlignment: calenderAlignment,
        calenderPadding: calenderPadding,
        calenderMargin: calenderMargin,
        monthYearFontFamily: monthYearFontFamily,
        monthYearFontStyle: monthYearFontStyle,
        monthYearFontWeight: monthYearFontWeight,
        monthYearFontSize: monthYearFontSize,
        monthYearTransformation: monthYearTransformation,
        monthYearDecoration: monthYearDecoration,
        monthYearColor: monthYearColor,
        hoverMonthYearTextColor: hoverMonthYearTextColor,
        hoverMonthYearBgColor: hoverMonthYearBgColor,
        weekFontFamily: weekFontFamily,
        weekFontStyle: weekFontStyle,
        weekFontWeight: weekFontWeight,
        weekFontSize: weekFontSize,
        weekTransformation: weekTransformation,
        weekDecoration: weekDecoration,
        weekdaysColor: weekDaysColor,
        hoverWeekTextColor: hoverWeekTextColor,
        hoverWeekBgColor: hoverWeekBgColor,
        weekLineHeight: weekLineHeight,
        dateWeekHeight: dateWeekHeight,
        dateWeekWidth: dateWeekWidth,
        dateWeekMargin: dateWeekMargin,
        dateBgColor: dateBgColor,
        hoverDateBgColor: hoverDateBgColor,
        dateBorderRadius: dateBorderRadius,
        dateBorderWidth: dateBorderWidth,
        dateBorderStyle: dateBorderStyle,
        dateBorderColor: dateBorderColor,
        dateBoxShadow: dateBoxShadow,
        dateFontFamily: dateFontFamily,
        dateFontStyle: dateFontStyle,
        dateFontWeight: dateFontWeight,
        dateFontSize: dateFontSize,
        dateTransformation: dateTransformation,
        dateDecoration: dateDecoration,
        daysColor: daysColor,
        hoverDateTextColor: hoverDateTextColor,
        dateLineHeight: dateLineHeight,
        currentDateBgColor: currentDateBgColor,
        currentDateBorderRadius: currentDateBorderRadius,
        currentDateBorderWidth: currentDateBorderWidth,
        currentDateBorderStyle: currentDateBorderStyle,
        currentDateBorderColor: currentDateBorderColor,
        currentDateBoxShadow: currentDateBoxShadow,
        currentDateFontFamily: currentDateFontFamily,
        currentDateFontStyle: currentDateFontStyle,
        currentDateFontWeight: currentDateFontWeight,
        currentDateFontSize: currentDateFontSize,
        currentDateTransformation: currentDateTransformation,
        currentDateDecoration: currentDateDecoration,
        currentDateTextColor: currentDateTextColor,
        daySelectedBg: selectedDateBgColor,
        selectedDateBorderRadius: selectedDateBorderRadius,
        selectedDateBorderWidth: selectedDateBorderWidth,
        selectedDateBorderStyle: selectedDateBorderStyle,
        selectedDateBorderColor: selectedDateBorderColor,
        selectedDateBoxShadow: selectedDateBoxShadow,
        selectedDateFontFamily: selectedDateFontFamily,
        selectedDateFontStyle: selectedDateFontStyle,
        selectedDateFontWeight: selectedDateFontWeight,
        selectedDateFontSize: selectedDateFontSize,
        selectedDateTransformation: selectedDateTransformation,
        selectedDateDecoration: selectedDateDecoration,
        daySelectedColor: selectedDateTextColor,
        dayRangeBg: dateRangeBgColor,
        dateRangeBorderRadius: dateRangeBorderRadius,
        dateRangeBorderWidth: dateRangeBorderWidth,
        dateRangeBorderStyle: dateRangeBorderStyle,
        dateRangeBorderColor: dateRangeBorderColor,
        dateRangeBoxShadow: dateRangeBoxShadow,
        dateRangeFontFamily: dateRangeFontFamily,
        dateRangeFontStyle: dateRangeFontStyle,
        dateRangeFontWeight: dateRangeFontWeight,
        dateRangeFontSize: dateRangeFontSize,
        dateRangeTransformation: dateRangeTransformation,
        dateRangeDecoration: dateRangeDecoration,
        dayRangeColor: dateRangeTextColor,
        disabledDateBgColor: disabledDateBgColor,
        disabledDateBorderRadius: disabledDateBorderRadius,
        disabledDateBorderWidth: disabledDateBorderWidth,
        disabledDateBorderStyle: disabledDateBorderStyle,
        disabledDateBorderColor: disabledDateBorderColor,
        disabledDateBoxShadow: disabledDateBoxShadow,
        disabledDateFontFamily: disabledDateFontFamily,
        disabledDateFontStyle: disabledDateFontStyle,
        disabledDateFontWeight: disabledDateFontWeight,
        disabledDateFontSize: disabledDateFontSize,
        disabledDateTransformation: disabledDateTransformation,
        disabledDateDecoration: disabledDateDecoration,
        disabledDateTextColor: disabledDateTextColor,
        monthFontFamily: monthFontFamily,
        monthFontStyle: monthFontStyle,
        monthFontWeight: monthFontWeight,
        monthFontSize: monthFontSize,
        monthTransformation: monthTransformation,
        monthDecoration: monthDecoration,
        monthTextColor: monthTextColor,
        hoverMonthTextColor: hoverMonthTextColor,
        hoverMonthBgColor: hoverMonthBgColor,
        currentMonthBgColor: currentMonthBgColor,
        currentMonthBorderRadius: currentMonthBorderRadius,
        currentMonthBorderWidth: currentMonthBorderWidth,
        currentMonthBorderStyle: currentMonthBorderStyle,
        currentMonthBorderColor: currentMonthBorderColor,
        currentMonthBoxShadow: currentMonthBoxShadow,
        currentMonthFontFamily: currentMonthFontFamily,
        currentMonthFontStyle: currentMonthFontStyle,
        currentMonthFontWeight: currentMonthFontWeight,
        currentMonthFontSize: currentMonthFontSize,
        currentMonthTransformation: currentMonthTransformation,
        currentMonthDecoration: currentMonthDecoration,
        currentMonthTextColor: currentMonthTextColor,
        selectedMonthBgColor: selectedMonthBgColor,
        selectedMonthBorderRadius: selectedMonthBorderRadius,
        selectedMonthBorderWidth: selectedMonthBorderWidth,
        selectedMonthBorderStyle: selectedMonthBorderStyle,
        selectedMonthBorderColor: selectedMonthBorderColor,
        selectedMonthBoxShadow: selectedMonthBoxShadow,
        selectedMonthFontFamily: selectedMonthFontFamily,
        selectedMonthFontStyle: selectedMonthFontStyle,
        selectedMonthFontWeight: selectedMonthFontWeight,
        selectedMonthFontSize: selectedMonthFontSize,
        selectedMonthTransformation: selectedMonthTransformation,
        selectedMonthDecoration: selectedMonthDecoration,
        selectedMonthTextColor: selectedMonthTextColor,
        yearFontFamily: yearFontFamily,
        yearFontStyle: yearFontStyle,
        yearFontWeight: yearFontWeight,
        yearFontSize: yearFontSize,
        yearTransformation: yearTransformation,
        yearDecoration: yearDecoration,
        yearTextColor: yearTextColor,
        hoverYearTextColor: hoverYearTextColor,
        hoverYearBgColor: hoverYearBgColor,
        currentYearBgColor: currentYearBgColor,
        currentYearBorderRadius: currentYearBorderRadius,
        currentYearBorderWidth: currentYearBorderWidth,
        currentYearBorderStyle: currentYearBorderStyle,
        currentYearBorderColor: currentYearBorderColor,
        currentYearBoxShadow: currentYearBoxShadow,
        currentYearFontFamily: currentYearFontFamily,
        currentYearFontStyle: currentYearFontStyle,
        currentYearFontWeight: currentYearFontWeight,
        currentYearFontSize: currentYearFontSize,
        currentYearTransformation: currentYearTransformation,
        currentYearDecoration: currentYearDecoration,
        currentYearTextColor: currentYearTextColor,
        selectedYearBgColor: selectedYearBgColor,
        selectedYearBorderRadius: selectedYearBorderRadius,
        selectedYearBorderWidth: selectedYearBorderWidth,
        selectedYearBorderStyle: selectedYearBorderStyle,
        selectedYearBorderColor: selectedYearBorderColor,
        selectedYearBoxShadow: selectedYearBoxShadow,
        selectedYearFontFamily: selectedYearFontFamily,
        selectedYearFontStyle: selectedYearFontStyle,
        selectedYearFontWeight: selectedYearFontWeight,
        selectedYearFontSize: selectedYearFontSize,
        selectedYearTransformation: selectedYearTransformation,
        selectedYearDecoration: selectedYearDecoration,
        selectedYearTextColor: selectedYearTextColor,
        datePickerPosition: datePickerPosition
      })
    })]
  });
};
exports.DatePickerInput = DatePickerInput;